import { TaskStatus, type Task } from "@/src/models/task";
import type { TaskStep } from "@/src/models/task-step";

export function getAwaitingInformationStep(
  task: Pick<Task, "status">,
  taskSteps: readonly TaskStep[]
): TaskStep | null {
  if (task.status !== TaskStatus.AWAITING_INFORMATION) return null;

  // Early exits are persisted as completed; the final recorded step is the one Resume retries.
  return taskSteps.toSorted((a, b) => a.stepIndex - b.stepIndex).at(-1) ?? null;
}
